import React, { ComponentProps, PropsWithChildren } from 'react';
import clsx from 'clsx';

import styles from './rich-text.module.css';

export const RichText = ({className, ...props} : {className?: string} & ComponentProps<'div'> & PropsWithChildren)  => {
  return (
    <div className={clsx(styles.text, className, 'contrib')} {...props}/>
  )
}